module.exports = __webpack_public_path__ + "static/logo-ef050ae4b412023f651e537ce81a8511.svg";